module.exports = __webpack_public_path__ + "img/n-h-page1-icon2.a011853f.png";